import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import colors from '../../../styles/colors';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 20px 70px;
  min-height: calc(100vh - 70px);
  background-color: rgb(24, 23, 18);
  border-top: 3px solid gold;
`;

const Title = styled.h1`
  font-size: 22px;
  font-weight: 700;
  color: gold;
  margin-bottom: 32px;
  text-align: center;
`;

const ButtonsCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  width: 100%;
  max-width: 340px;
`;

const NavBtn = styled.button<{ $accent?: string }>`
  width: 100%;
  padding: 16px 18px;
  background-color: ${colors.bgColorBlack2};
  border: 2px solid ${({ $accent }) => $accent ?? 'gold'};
  border-radius: 10px;
  color: ${({ $accent }) => $accent ?? 'gold'};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: background-color 0.15s;

  &:active {
    background-color: ${({ $accent }) => $accent ?? 'gold'}1a;
  }
`;

const BtnLeft = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
`;

const BtnLabel = styled.span`
  font-size: 16px;
  font-weight: 700;
`;

const BtnSub = styled.span`
  font-size: 11px;
  font-weight: 400;
  opacity: 0.6;
`;

const BtnArrow = styled.span`
  font-size: 18px;
  opacity: 0.5;
`;

const CatalogMobileLandingPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Container>
      <Title>Catalog — Founder</Title>
      <ButtonsCol>
        <NavBtn $accent="gold" onClick={() => navigate('/admin/catalog/dashboard')}>
          <BtnLeft>
            <BtnLabel>Dashboard</BtnLabel>
            <BtnSub>Statistiche generali catalogo</BtnSub>
          </BtnLeft>
          <BtnArrow>›</BtnArrow>
        </NavBtn>

        <NavBtn $accent="#4a9eff" onClick={() => navigate('/admin/users')}>
          <BtnLeft>
            <BtnLabel>Crediti Utenti</BtnLabel>
            <BtnSub>Gestisci crediti e inventari</BtnSub>
          </BtnLeft>
          <BtnArrow>›</BtnArrow>
        </NavBtn>
      </ButtonsCol>
    </Container>
  );
};

export default CatalogMobileLandingPage;
